import React from 'react';
import FooterHero from '../../component/common/CTA'
import HeroSection from '../../component/common/hero'
import HowWeHelp from '../../component/common/howWeHelp'
import CaseStudySlider from '../../component/common/caseStudy'
import { Helmet } from 'react-helmet-async';
import Banner from '../../component/common/Banner';
import CirclePoints from '../../component/common/circlePoints';
import { FaArrowRight } from 'react-icons/fa6';
import Reviews from '../../component/common/reviews';
import ExpansionFrameworkSection from '../../component/common/ExpansionSection';

const caseStudiesData = [
  {
    image: "img/logos/whizdom.png",
    heading: {bold : "Whizdom India (by MQDC Thailand) " , light : '– Premium Co-Working Expansion'},
    content : [
      {title : 'Challenge' , description : 'Thai real estate giant MQDC wanted to launch its innovation-focused co-working brand, Whizdom Club, in India.'},
      {title : 'TurningIdeas Role' , description : 'We built the entire India go-to-market plan — including positioning, strategic partnerships, startup events calendar, and early member onboarding strategy.'},
      {title : 'Outcome' , description : 'The brand launched in Delhi with full programmatic support, 30+ startup/VC tie-ups, and high-quality occupancy from day one.'}
    ]
  },
  {
    image: "img/logos/cloudverse.png",
    heading: {bold : "Cloudverse.ai " , light : 'Enterprise SaaS for Cloud FinOps'},
    content : [
      {title : 'Challenge' , description : 'The product had traction in Asian Markets , but was challenged to scale in India with GTM repeatability and investor storytelling.'},
      {title : 'TurningIdeas Role' , description : 'We created customer segmentation models, product marketing content, and an investor narrative grounded in real wins. We also unlocked PoCs in manufacturing and retail.'},
      {title : 'Outcome' , description : 'The startup evolved from pilot-stage to growth-ready with enterprise references and a strong case for follow-on funding.'}
    ]
  },
];

const heroData = {
  title: {
    bold: "Global",
    light: "Startups",
  },
  subtitle: "Expand in India with Confidence",
  description: {
    heading: "Entering India's Market? We Make It Seamless.",
    intro: "India is one of the fastest-growing markets, but",
    outro: "can be complex. We simplify it for you."
  },
  highlightedText: "navigating regulations, finding the right partners, and scaling effectively",
  heroImage: "img/global-hero.png",
  bgImg: "img/global-hero-bg.png",
  btnText: "Expand in India",
  btnLink: "https://forms.gle/MAgquUKQDY4k9gjH8"
};


const serviceCards = [
  {
    title: "Market Research & Localization",
    text: "Understanding Indian consumers & competition.",
    subtext: "",
    iconLink: "img/global-help1.png" // Target icon
  },
  {
    title: "Regulatory & Compliance Support",
    text: "Helping you comply with local laws.",
    subtext: "",
    iconLink: "img/global-help2.png"
  },
  {
    title: "Business Development & Sales",
    text: "Connecting you with customers & distributors.",
    subtext: "",
    iconLink: "img/global-help3.png" // Growth chart icon
  },
  {
    title: "Strategic Partnerships & Fundraising",
    text: "Enabling faster growth through investor & enterprise connections.",
    subtext: "",
    iconLink: "img/global-help4.png" // Rocket icon
  }
];

const statsDataHeading = {
  light: "Why Expand in",
  bold: "India?"
}

const statsData = [
  {
    title: "$3.5 Trillion Economy",
    text: "Rapid digital adoption & growing middle class."
  },
  {
    title: "Largest Startup Ecosystem in Asia",
    text: "100K+ startups & rising investment."
  },
  {
    title: "Massive Untapped Market",
    text: "Over 1.4 billion consumers"
  }
];

const worldMapImg = "img/why-global.png";


const headerData = {
  title: "How We Help",
  highlightedText: "Global Scaleups",
  normalText: "Startups",
  description: "From idea to exit, together. when we partner with founders, we're all in combining expertise, empathy, embedded resources, and capital to build breakout companies",
  imgLink: "img/help-global.png"
};

const BANNER_CONTENT = [{ subHeading : 'You’ve Raised Capital. Now Let’s Build Momentum' , description : 'We help global startups land and scale in India – with local teams, enterprise access, and go-to-market support' , url : 'https://forms.gle/MAgquUKQDY4k9gjH8' , linkText: 'Apply Now'}]

const PAIN_POINTS = [
  { img : 'img/indian-journey-1.png' , figCaption : 'Align' , description : 'Discovery call to understand your goals'},
  {img : 'img/indian-journey-2.png' , figCaption : 'Adapt' , description : 'Market research + product localization'},
  {img : 'img/indian-journey-3.png' , figCaption : 'Assemble' , description : 'Hire local team or dev squad'},
  {img : 'img/indian-journey-4.png' , figCaption : 'Activate' , description : 'GTM, partnerships, PR'},
  {img : 'img/indian-journey-5.png' , figCaption : 'Accelerate' , description : 'Traction support & investor access'},
]

const HOW_IT_WORKS = [
  {img : 'img/indian-journey-1.png' , heading : 'Align' , description : 'Understand Your Goals & Market Fit' , content : 'We start with a deep-dive strategy sprint to understand your business model, ICP, pricing, and competitive landscape. We map your product’s readiness for the Indian market and identify quick-win segments.' , points : ['Market dynamics & opportunity sizing' , 'Market dynamics & opportunity sizing' , 'India readiness assessment' , 'Localization needs (product + pricing)']},
  {img : 'img/how-it-works-scale-2.png' , heading : 'Adapt' , description : 'Localize Your Product & Value Proposition' , content : 'Entering India requires more than translation — it needs optimization.We help you localize your product, positioning, and messaging for Indian buyers.' , points : ['Product localization plan' , 'Messaging & pitch customization' , 'Compliance & legal integration guidance' , 'Pricing model transformation (INR, SaaS plans, consumption models)']},
  {img : 'img/how-it-works-scale-3.png' , heading : 'Assemble' , description : 'Build Your Local Team Without Full-Time Hiring' , content : 'Instead of spending months building a team, we become your India execution arm.' , points : ['Local GTM experts' , 'Sales development teams' , 'Technical talent / development squads' , 'Channel partner networks']},
  {img : 'img/how-it-works-scale-4.png' , heading : 'Activate' , description : 'Launch Go-To-Market & Acquire Customers' , content : 'We take your offering to the Indian market with speed and precision.' , points :[ 'B2B/B2C GTM' , 'Demo pipeline creation' , 'Enterprise introductions' , 'Channel partnerships' , 'PR & ecosystem visibility' , 'Pilot programs with early customers']},
]

const GlobalPage = () => {
  return (
    <div>

      <Helmet>
        <title>Launch and Scale Your Startup in India with TurningIdeas</title>
        <meta name="description" content="TurningIdeas helps global founders localize, launch, and grow in India with tech execution, regulatory guidance, GTM support, and enterprise access." />
        <meta name="keywords" content="global startup in India, localize startup India, India GTM support, startup expansion India" />
      </Helmet>

      <Banner content={BANNER_CONTENT} img='img/Banner/Global.png' />

      <CirclePoints heading='Your India Journey in 5 Steps' points={PAIN_POINTS} className='grid grid-cols-1 min-[565px]:grid-cols-2 min-[622px]:grid-cols-3 min-[1068px]:grid-cols-5 gap-y-10' />

      <section className="container max-w-7xl mx-auto px-6 md:px-12">
        <HowWeHelp
          headerData={headerData}
          serviceCards={serviceCards}
          statsDataHeading={statsDataHeading}
          statsData={statsData}
          worldMapImg={worldMapImg}
        />
      </section>

      <ExpansionFrameworkSection HOW_IT_WORKS={HOW_IT_WORKS} heading='How It Works' subHeading='Launch and Scale in India Without the Complexity' description='Expanding into India can be overwhelming — regulatory requirements, cultural nuances, hiring, GTM, distribution, pricing, and enterprise access. TurningIdeas simplifies it into a proven 5-step expansion framework built for global founders.' />

      <section className="container max-w-7xl mx-auto px-6 md:px-12 py-6 md:py-12 bg-black">
          <CaseStudySlider caseStudies={caseStudiesData} />
      </section>

      <FooterHero
        heading="Want a Partner to Co-Build"
        paragraph="Whether you're a Startup, Investor or Enterprise, We help you Scale, Innovate and Succeed."
        buttonText="Contact Us Today!"
      />
    </div>
  );
};

export default GlobalPage;
